const getExtraPageTitle = (title) => title;

export default getExtraPageTitle;
